import { Button, Card, Modal, notification, Popconfirm, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { useIsAuthenticated } from '@azure/msal-react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useLazyQuery, useMutation } from '@apollo/client';
import CostClaimForm from './CostClaimForm';
import { DELETE_COST_CLAIM, GET_COST_CLAIMS } from './CostClaimQueries';

const CostClaimList = () => {
  const isAuthenticated = useIsAuthenticated();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { proceedingId } = useParams<any>();
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const tab = searchParams.get('tab');
  const [costClaimList, setCostClaimList] = useState(null);
  const getFormTitle = () => {
    if (isAuthenticated) {
      return (id !== null ? 'Edit' : 'Add') + ' Cost Claim';
    }
    return 'View Cost Claim';
  };
  const [getCostClaims, { data: costClaimResponse, refetch }] = useLazyQuery(GET_COST_CLAIMS);
  const [deleteCostClaimFromCostOrder, { data: deleteResult, error: deleteError }] =
    useMutation(DELETE_COST_CLAIM);
  useEffect(() => {
    if (tab === '9' && proceedingId) {
      getCostClaims({
        variables: {
          input: proceedingId,
        },
      });
    }
  }, [tab, proceedingId]);
  useEffect(() => {
    if (costClaimResponse?.costClaims?.data && Array.isArray(costClaimResponse.costClaims.data)) {
      setCostClaimList(costClaimResponse.costClaims.data);
    } else {
      setCostClaimList([]);
    }
  }, [costClaimResponse]);

  const editViewCostClaim = (costClaim: any) => {
    setId(costClaim.id);
    handleModalOpen();
  };
  const deleteCostClaim = async (costClaim: any) => {
    await deleteCostClaimFromCostOrder({
      variables: {
        input: {
          proceedingNumber: proceedingId,
          costClaimId: costClaim.id,
        },
      },
    });
    refetch();
  };

  useEffect(() => {
    if (deleteResult && deleteResult.deleteCostClaim.result === 'Success') {
      notification.success({
        message: 'Success',
        description: `Cost Claims has been deleted.`,
      });
    }

    if (deleteResult && deleteResult.deleteCostClaim.result === 'Error') {
      notification.error({
        message: 'Error',
        description: `Error in deleting Cost Claims.`,
      });
    }
    refetch();
  }, [deleteResult, deleteError]);

  const handleModalOpen = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setId(null);
    refetch();
  };
  const handleFormSubmit = () => {
    refetch();
    setIsModalVisible(false);
    setId(null);
  };

  const costClaimColumns: any[] = [
    {
      title: 'Party Name',
      dataIndex: 'partyName',
      key: 'partyName',
    },
    {
      title: 'Cost Claim Date',
      dataIndex: 'costClaimDate',
      key: 'costClaimDate',
    },
    {
      title: 'Cost Claim Comment',
      dataIndex: 'costClaimComment',
      key: 'costClaimComment',
    },
  ];
  if (isAuthenticated) {
    costClaimColumns.push({
      title: 'Delete',
      key: 'deleteIcon',
      onCell: () => {
        return {
          onClick: (event: any) => {
            event.stopPropagation();
          },
        };
      },
      render: (_: any, costClaim: any) => {
        return (
          <>
            <div className="ml-1 inline-block">
              <Popconfirm
                title="Delete Cost Claim"
                description={'Are you sure to delete this cost claim?'}
                onConfirm={() => deleteCostClaim(costClaim)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  icon={<DeleteOutlined />}
                  size={'small'}
                  style={{ backgroundColor: 'white', color: 'red' }}
                />
              </Popconfirm>
            </div>
          </>
        );
      },
    });
  }
  return (
    <>
      <Card
        title={<span className="highlighted-title">Cost Claims</span>}
        style={{ marginTop: '10px', marginLeft: '0px', width: '900px' }}
        className="card"
        extra={
          isAuthenticated && (
            <Button onClick={handleModalOpen} type="primary">
              Add
            </Button>
          )
        }
      >
        <Table
          columns={costClaimColumns}
          dataSource={costClaimList}
          onRow={(costClaim: any) => ({
            onClick: () => {
              editViewCostClaim(costClaim);
            },
            style: { cursor: 'pointer' },
          })}
          rowClassName="clickable-row"
        />
      </Card>
      <Modal
        title={getFormTitle()}
        open={isModalVisible}
        onCancel={handleModalClose}
        width={800}
        footer={null}
        destroyOnClose
      >
        <CostClaimForm
          onSubmit={handleFormSubmit}
          onCancel={handleModalClose}
          proceedingId={proceedingId}
          id={id}
        />
      </Modal>
    </>
  );
};
export default CostClaimList;
